module.exports = __webpack_public_path__ + "img/icn-menu.37a0a119.svg";